export default __webpack_public_path__ + "static/Oxygen-SMSF-Rate-Card-2-November-2022-1a424abefcea2d6760e930643d5f7d15.pdf";